'use client'

import React from "react"

import Image from "next/image"

import * as S from '../PostBody.styles'

const BodyImage = ({ image }) => {
  const { url, alternativeText } = image

  return (
    <S.BodyImage>
      <Image src={url} alt={alternativeText} fill sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 100vw" />
    </S.BodyImage>
  )
}

export default BodyImage
